import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone"}/>
}
